import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import TableCell from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableCell';
import WarningIcon from 'Components/ComponentLibrary/Components/Uncategorized/Icons/WarningIcon';
import TableCellContent from './TableCellContent';

const styles = theme => ({
  root: {
    padding: theme.spacing(1),
  },
  warningIcon: {
    marginRight: theme.spacing(1),
  },
});

const TableHeadItem = ({
  item,
  className,
  classes,
}) => {
  const { title, warningMessage } = item;

  return (
    <TableCell
      className={classNames(classes.root, className)}
    >
      <TableCellContent>
        {warningMessage ? (
          <Tooltip title={warningMessage}>
            <div className={classes.warningIcon}>
              <WarningIcon />
            </div>
          </Tooltip>
        ) : null}
        <Typography
          variant={'h5'}
          color={warningMessage ? 'orange' : 'primary'}
          noWrap
          weight={'bold'}
          align={'right'}
        >
          {title}
        </Typography>
      </TableCellContent>
    </TableCell>
  );
};

TableHeadItem.defaultProps = {
  className: '',
  item: null,
};

TableHeadItem.propTypes = {
  item: PropTypes.object,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableHeadItem);
